// Types
import { CollectionPointProps } from 'types/CollectionPoint.types';

//
import { CO_OP_MIDCOUNTIES_OWNER_ID } from '../../constants/clickCollectConstants';
import { isExtendedNetworkStore } from './isCollectionPointAvailable';
import { isCollectPlusRelatedType, getCollectionRelatedStore } from './getCollectPlusRelatedStores';

export const getSelectedStoreUnavailableMessage = (
  collectionPoint: CollectionPointProps = {},
  collectPlusAvailable: boolean = true,
) => {
  if (Object.keys(collectionPoint).length === 0) {
    return null;
  }

  const {
    ownerId,
    type,
    isAvailable,
    unavailabilityReason,
  } = collectionPoint;

  if (ownerId && !collectPlusAvailable && isExtendedNetworkStore(ownerId)) {
    let storeType = type;
    if (isCollectPlusRelatedType(ownerId)) {
      storeType = getCollectionRelatedStore(ownerId).name;
    }

    if (ownerId === CO_OP_MIDCOUNTIES_OWNER_ID) {
      storeType = 'Co-Op Midcounties';
    }

    return {
      body: `An item in your basket cannot be delivered to ${storeType} shops. Please change your shop to continue.`,
      title: 'This shop is unavailable',
      dataTestId: undefined,
    };
  }

  if (!isAvailable) {
    return {
      body: 'Please change your shop to continue.',
      title: unavailabilityReason,
      dataTestId: 'click-collect-selected-point-unavailable',
    };
  }

  return null;
};
